import React, { useState }        from 'react';
import Modal                      from 'react-bootstrap/Modal';
import CloseBtn                   from 'assets/icons/Close.svg';
import MoreButton                 from 'assets/icons/More.svg';
import { ConfirmationCodeInput }  from './ConfirmationCodeInput';
import { formatCurrency, nricOrPassport, standardDate } from 'helpers/common.helper';

export function ConfirmAttendance(data) {
  const info            = data.data.personal_info;
  const [show, setShow] = useState(false);
  const handleShow      = () => setShow(true);

  const handleClose     = () => {
    setShow(false);
    window.location.reload();
  }

  const patientInfo     = [
    { title: 'Policy Owner',      value: info.policy_owner },
    { title: 'NRIC/Passport No.', value: nricOrPassport(info.nric) },
    { title: 'Membership No.',    value: info.membership_np },
    { title: 'Effective Date',    value: standardDate(info.effective_date) },
    { title: 'Company Name',      value: info.company_name },
    { title: 'Employee\'s ID',    value: info.corporate_employee_id },
    { title: 'Visit Limit',       value: 'MYR ' + formatCurrency(data.data.claim_limit) },
    { title: 'Practice Location', value: data.data.practice_location.name }
  ]

  const byChunks        = patientInfo.reduce((memo, value, index) => {
    if (index % 2 === 0 && index !== 0) memo.push([])
    memo[memo.length - 1].push(value)
    return memo
  }, [[]]);

  const informationRows = byChunks.map((array, index) => {
    return (
      <div className="row" key={ index }>
        <div className="col">
          <p className="text-lightgrey mb-0 font-size-3">{ array[0]?.title }</p>
          <p><b>{ array[0]?.value || '-'  }</b></p>
        </div>

        <div className="col">
          <p className="text-lightgrey mb-0 font-size-3">{ array[1]?.title }</p>
          <p><b>{ array[1] ? (array[1]?.value || '-') : null }</b></p>
        </div>
      </div>
    )
  });

  const disclaimerList  = [
    'By confirming your patient’s attendance, you are responsible for the consultation which include diagnosis, treatment and other matters as related to the medical appointment.',
    'Once you entered the correct Visit Number, you will be directed to the “Open Claims” section to create the patient’s medical bill document(s).',
    'You are NOT able to undo this Confirm Attendance’ step.'
  ];

  const disclaimer      = disclaimerList.map((text, index) => {
    const withNoMargin  = index + 1 < disclaimerList.length ? '' : ' mb-0';

    return (
      <div className="d-flex font-size-3" key={ index }>
        <p className={ "w-em-4 flex-shrink-0" + withNoMargin }>{ index + 1 }.</p>
        <p className={ withNoMargin }>{ text }</p>
      </div>
    )
  });

  return (
    <div>
      <img src={ MoreButton } alt="more-options" className="more-options d-block d-lg-none" onClick={ handleShow } />
      <button className="btn btn-danger rounded-pill w-em-20 py-3 d-none d-lg-block" onClick={ handleShow }>Attend</button>

      <Modal show={ show } onHide={ handleClose } keyboard={ false } size="lg" centered>
        <Modal.Header>
          <Modal.Title>Pre-registered by</Modal.Title>

          <button type="button" className="close" onClick={ handleClose }>
            <img src={ CloseBtn } alt="modal-close" />
          </button>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-3">
            { informationRows }
          </div>

          <div className="bg-veryfaint text-grey p-10">
            <h5 className="text-center">Confirm Attendance</h5>
            <p className="text-center">To accept this patient's pre-registration attendance, <b>please request for their visit number</b> and enter it below.</p>
            <ConfirmationCodeInput id={ data.data.id } />
            <p className="text-danger font-size-4"><b>Disclaimer</b></p>
            { disclaimer }
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}